
import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface SlideNavigationProps {
  currentSlideIndex: number;
  totalSlides: number;
  slideTitle: string;
  onPrevSlide: () => void;
  onNextSlide: () => void;
  onSlideSelect: (index: number) => void;
}

const SlideNavigation = ({
  currentSlideIndex,
  totalSlides,
  slideTitle,
  onPrevSlide,
  onNextSlide,
  onSlideSelect,
}: SlideNavigationProps) => {
  return (
    <div className="flex justify-between items-center mb-12">
      <Button 
        variant="outline" 
        onClick={onPrevSlide}
        size="icon"
        className="rounded-full w-12 h-12 border-indigo-400 text-indigo-600 hover:bg-indigo-100 bg-transparent"
      >
        <ChevronLeft className="h-6 w-6" />
      </Button>
      <div className="text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-600 via-purple-600 to-pink-600 mb-4 font-cursive">
          {slideTitle}
        </h2>
        <div className="flex items-center justify-center space-x-2">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              onClick={() => onSlideSelect(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentSlideIndex
                  ? "bg-gradient-to-r from-indigo-500 to-purple-500 w-6"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
      <Button 
        variant="outline" 
        onClick={onNextSlide}
        size="icon"
        className="rounded-full w-12 h-12 border-indigo-400 text-indigo-600 hover:bg-indigo-100 bg-transparent"
      >
        <ChevronRight className="h-6 w-6" />
      </Button>
    </div>
  );
};

export default SlideNavigation;
